// Generic mock for React Native modules
import React from 'react';

// Create a function that builds mock components
const createMockComponent = (name) => {
  const component = ({ children, style, ...props }) => {
    return React.createElement(
      'div',
      {
        className: `mock-${name}`,
        style,
        'data-mock': name,
        ...props,
      },
      children
    );
  };

  component.displayName = name;
  return component;
};

// Common mock components
export const View = createMockComponent('View');
export const Text = createMockComponent('Text');
export const Image = createMockComponent('Image');
export const ScrollView = createMockComponent('ScrollView');
export const TouchableOpacity = createMockComponent('TouchableOpacity');

// Mock APIs
export const Dimensions = {
  get: () => ({ width: 375, height: 812 }),
  addEventListener: () => {},
  removeEventListener: () => {},
};

export const Platform = {
  OS: 'web',
  select: (obj) => obj.web || obj.ios || obj.default,
};

export default {
  createMockComponent,
  View,
  Text,
  Image,
  ScrollView,
  TouchableOpacity,
  Dimensions,
  Platform,
};
